import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  CustomerReportingToastService,
  ReportToast,
} from '../../services/customer-reporting-toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './report-toast.component.html',
  styleUrls: ['./report-toast.component.scss'],
})
export class ReportToastComponent implements OnInit {
  @Input() toast: ReportToast;
  @Output() closeToast = new EventEmitter<void>();

  constructor(private toastService: CustomerReportingToastService) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  onClose(): void {
    this.closeToast.emit();
  }

  filterClick(): void {
    this.toastService.onToastClick(this.toast);
  }
}
